export function createXLSheetdata(headCountList,brandGroups) {
    headCountList.find((ticketDetails, index) => {
                
                
                delete headCountList[index]['id']

                headCountList[index].Kitchen=headCountList[index].name
                delete headCountList[index]['name']

                headCountList[index].Header=headCountList[index].header
                delete headCountList[index]['header']


                     headCountList[index].KitchenManager=headCountList[index].data['km']
                     headCountList[index].AsstKitchenManager=headCountList[index].data['akm']
                     headCountList[index].ShiftManager=headCountList[index].data['sm']
                     headCountList[index].HouseKeeping=headCountList[index].data['hk']

                for (var i = 0; i < brandGroups.length; i++) {
                     headCountList[index][brandGroups[i]['name']]=headCountList[index].data[brandGroups[i]['name']]
                }


                     headCountList[index].NotAssigned=headCountList[index].data['not assigned']
                delete headCountList[index]['data']

                return false
            })   
            return headCountList
}




// WEBPACK FOOTER //
// ./src/modules/Attendance Summary/services/helpers.js